require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-world-bank-energy-directions-has-the-bank-fulfilled-1.json") })
        }
      }, "path---en-us-update-world-bank-energy-directions-has-the-bank-fulfilled-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-world-bank-energy-directions-has-the-bank-fulfilled-1!./.cache/json/en-us-update-world-bank-energy-directions-has-the-bank-fulfilled-1.json
// module id = 874
// module chunks = 231608221292675